export type JobResumeStep = 'spaces' | 'assets' | 'jobs';

/** Job "Continue Setup" resume → ConversationalOnboarding UI step */
export const JOB_RESUME_UI_STEP = {
  spaces: 5,
  assets: 6,
  jobs: 7,
} as const satisfies Record<JobResumeStep, 5 | 6 | 7>;

/**
 * Backend `currentStep` is the last completed step.
 * 2 = property done → spaces, 3 = spaces done → assets, 4 = assets done → jobs.
 */
export const BACKEND_COMPLETED_TO_UI_STEP: Record<number, 5 | 6 | 7> = {
  2: 5,
  3: 6,
  4: 7,
};

export function mapJobResumeStep(step: JobResumeStep): 5 | 6 | 7 {
  return JOB_RESUME_UI_STEP[step];
}

export function mapBackendOnboardingStep(
  currentStep: number | null | undefined
): 0 | 5 | 6 | 7 {
  if (!currentStep) {
    return 0;
  }
  return BACKEND_COMPLETED_TO_UI_STEP[currentStep] ?? 0;
}

/**
 * Reload resume must not run mid-session when the backend step advances.
 * It only applies on a fresh load with an in-progress step and at least one site.
 */
export function shouldApplyReloadResume(input: {
  hasStartedInSession: boolean;
  currentStep: number | null | undefined;
  hasSites: boolean;
}): boolean {
  if (input.hasStartedInSession) {
    return false;
  }
  if (!input.currentStep || input.currentStep <= 0) {
    return false;
  }
  return input.hasSites;
}
